import React, { Component } from 'react';
import classes from './RecommendedSolution.module.scss';

import {connect} from "react-redux";

import FormattedPrice from '../../../components/FormattedPrice/FormattedPrice';
import Aux from '../../../hoc/Aux';

import { ReactComponent as WebsiteLogo } from '../../../assets/icons/bf-icon-website.svg';
import { ReactComponent as LLMLogo } from '../../../assets/icons/bf-icon-llm.svg';
import { ReactComponent as SMMLogo } from '../../../assets/icons/bf-icon-smm.svg';
import { ReactComponent as PPCLogo } from '../../../assets/icons/bf-icon-ppc.svg';
import { ReactComponent as RRMLogo } from '../../../assets/icons/bf-icon-rrm.svg';
import MSEBanner from '../../../assets/erie-mse-banner.png';

class RecommendedSolution extends Component {

    Constants = require( '../../../data/' + this.props.mode + '-constants.js' );

    buildSolutionIncludes = ( theSolution ) => {

        let includedTotalPrice = 0;

        return (
            <Aux>

                {theSolution.includes.map( productKey => {
                    includedTotalPrice = ( this.Constants.SOLUTIONS[ productKey ].price + includedTotalPrice );
                    return (
                        <div key={productKey} className={classes.IncludedProduct}>
                            <div className={classes.Icon}>{this.buildProductIcon( productKey )}</div>
                            <div className={[classes.Solution,classes['FG-'+productKey.toLowerCase()]].join(' ')}>{this.Constants.SOLUTIONS[ productKey ].label}</div>
                            <div className={classes.Description}>{this.Constants.SOLUTIONS[ productKey ].description}</div>
                            <div className={[classes.ReasonTitle,classes['FG-'+productKey.toLowerCase()]].join(' ')}>{this.props.verbiage}</div>
                            <div className={classes.Reason}>{this.props.reason[ productKey ]}</div>


                            { ( this.Constants.SOLUTIONS[ productKey ].hasOwnProperty( 'discountedPrice' ) ) ? (
                                <div className={classes.IncludedProductDiscountedPrice}>
                                    <em><FormattedPrice price={this.Constants.SOLUTIONS[ productKey ].price} /></em>
                                    <span><FormattedPrice price={this.Constants.SOLUTIONS[ productKey ].discountedPrice} /></span><br />per month
                                </div>
                            ) : (
                                <div className={classes.IncludedProductPrice}><span><FormattedPrice price={this.Constants.SOLUTIONS[ productKey ].price} /></span><br />per month</div>
                            ) }

                        </div>
                    );
                } ) }

            </Aux>
        );

    };

    buildProductIcon = ( productKey ) => {

        switch( productKey ) {
            case "WEBSITE":
                return <WebsiteLogo />;
            case "SEO_BUNDLE":
                return <WebsiteLogo />;
            case "LLM":
                return <LLMLogo />;
            case "SMM":
                return <SMMLogo />;
            case "PPC":
                return <PPCLogo />;
            case "RRM":
                return <RRMLogo />;
            default:
                return;
        }

    };

    render() {

        const theSolution = this.Constants.SOLUTIONS[ this.props.solution ];

        if( theSolution.hasOwnProperty( 'includes' ) && theSolution.includes.length ) {

            const solutionIncludes = this.buildSolutionIncludes( theSolution );

            const descriptionClasses = ( this.props.mode === 'erie' ) ? [classes.Description, classes.DescriptionMSE].join(' ') : classes.Description;

            return (
                <div className={[classes.RecommendedSolution, classes.Bundle].join(' ')}>
                    <div className={classes.Includes}>{solutionIncludes}</div>
                    <div className={descriptionClasses}>
                        { ( this.props.mode === 'erie' ) ? ( <div className={classes.BundleMSEBanner}><img src={MSEBanner} alt="MSE" /></div> ) : false }
                        <div className={classes.DescriptionLabel}>Great News!</div>
                        <div className={classes.DescriptionText}>These three recommendations are part of our <strong>{theSolution.label}! You'll save ${theSolution.savings} per month by bundling these services.</strong>
                        </div>
                    </div>
                </div>
            );

        }

        let mseClass = '';

        if ( theSolution.hasOwnProperty( 'mse' ) ) {
            mseClass = classes.MSE;
        }

        return (
            <div className={[classes.RecommendedSolution,classes['Border-'+this.props.solution.toLowerCase()],classes['LightBG-'+this.props.solution.toLowerCase()],mseClass].join(' ')}>
                <div className={classes.Icon}>{this.buildProductIcon(this.props.solution)}</div>
                <div className={[classes.Solution,classes['FG-'+this.props.solution.toLowerCase()]].join(' ')}>{theSolution.label}</div>
                <div className={classes.Description}>{theSolution.description}</div>
                <div className={[classes.ReasonTitle,classes['FG-'+this.props.solution.toLowerCase()]].join(' ')}>{this.props.verbiage}</div>
                <div className={classes.Reason}>{this.props.reason}</div>
                { ( theSolution.hasOwnProperty( 'mse' ) ) ? (
                    <Aux>
                        <div className={classes.MSEBanner}><img src={MSEBanner} alt="MSE" /></div>
                        { ( theSolution.hasOwnProperty( 'discountedPrice' ) ) ? (
                            <div className={[classes.DiscountedPrice,classes.MSE].join(' ')}>
                                <em><FormattedPrice price={theSolution.price} /></em>
                                <span><FormattedPrice price={theSolution.discountedPrice} /></span><br />per month
                            </div>
                        ) : (
                            <div className={[classes.Price,classes.MSE].join(' ')}><span><FormattedPrice price={theSolution.price} /></span><br />per month</div>
                        ) }
                    </Aux>
                ) : (
                    <Aux>
                        { ( theSolution.hasOwnProperty( 'discountedPrice' ) ) ? (
                            <div className={classes.DiscountedPrice}>
                                <em><FormattedPrice price={theSolution.price} /></em>
                                <span><FormattedPrice price={theSolution.discountedPrice} /></span><br />per month
                            </div>
                        ) : (
                            <div className={classes.Price}><span><FormattedPrice price={theSolution.price} /></span><br />per month</div>
                        ) }
                    </Aux>
                ) }
            </div>
        );

    }

}

const mapStateToProps = state => {
    return {
        mode: state.mode
    }
};

export default connect( mapStateToProps )( RecommendedSolution );
